module.exports = __webpack_public_path__ + "static/media/vampire.be88452b.mp3";